import classNames from 'classnames'
import * as PropTypes from 'prop-types'
import React from 'react'

import s from './FieldText.module.scss'
import FieldTextControlLayout from './FieldTextControlLayout/FieldTextControlLayout'

export default function FieldText({
  className,
  disabled,
  inputMode,
  id,
  inputRef,
  invalid,
  maxLength,
  name,
  onChange,
  onClearClick,
  placeholder,
  size
}) {
  const input = (
    <input
      className={classNames(
        s.field,
        { [s.clearable]: !!onClearClick, [s.invalid]: invalid, [s.small]: size === 's' },
        className
      )}
      disabled={disabled}
      id={id}
      inputMode={inputMode}
      maxLength={maxLength}
      name={name}
      onChange={onChange}
      placeholder={placeholder}
      ref={inputRef}
      type="text"
    />
  )

  return onClearClick ? (
    <FieldTextControlLayout invalid={invalid} onClearClick={onClearClick} size={size}>
      {input}
    </FieldTextControlLayout>
  ) : (
    input
  )
}

FieldText.propTypes = {
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
  disabled: PropTypes.bool,
  id: PropTypes.string,
  inputMode: PropTypes.string,
  inputRef: PropTypes.func,
  invalid: PropTypes.bool,
  maxLength: PropTypes.number,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  onClearClick: PropTypes.func,
  placeholder: PropTypes.string,
  size: PropTypes.string
}
